import React, { useEffect, useRef, useState } from "react";

const InputLikeDropdown = ({ options = [], placeholder = "Select/Unselect option", value, setValue }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="position-relative w-100 mb-3" ref={dropdownRef}>
      <p style={{
        fontSize: "12px",
        color: "#454545",
        padding: "0",
        marginBottom: "6px",
        fontWeight: "500",
      }}>ADD GROUP</p>
      {/* Input-looking field */}
      <div
        className="form-control d-flex justify-content-between  align-items-center"
        style={{
          cursor: "pointer",
          border: "1px solid #ebebeb",
          height: "50px",
        }}
        onClick={() => setOpen(prev => !prev)}
      >
        <span>{value?.name || placeholder}</span>
        <i className="bi bi-chevron-down"></i>
      </div>

      {/* Dropdown list */}
      {open && (
        <ul
          className="list-group position-absolute w-100"
          style={{
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          <li
            className="list-group-item list-group-item-action"
            onClick={() => {
              setValue(null);
              setOpen(false);
            }}
            style={{ cursor: "pointer" }}
          >
            Select option
          </li>

          {options.map((opt, idx) => (
            <li
              key={opt?.id}
              className="list-group-item list-group-item-action"
              onClick={() => {
                setValue(opt);
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {opt?.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default InputLikeDropdown;
